export const bulkCalendarDrawer = {
  header: {
    eyebrow: "Modifica in blocco",
    title: "Calendario in blocco",
    subtitle: "Chiudi, apri o modifica più unità contemporaneamente.",
  },
  actions: {
    close: {
      label: "Chiudi date",
      hint: "Applica un blocco manuale rispettando prenotazioni e sincronizzazione.",
    },
    open: {
      label: "Apri date",
      hint: "Riapre solo i giorni selezionati senza toccare il resto del blocco.",
    },
    price: {
      label: "Modifica prezzo",
      hint: "Aggiorna il prezzo a notte per le date e gli alloggi scelti.",
    },
    minStay: {
      label: "Soggiorno minimo",
      hint: "Imposta le notti minime per data in blocco.",
    },
  },
  microcopy: {
    close: "Blocco manuale",
    open: "Apertura parziale",
    price: "Tariffa a notte",
    minStay: "Notti minime",
  },
  step1: {
    title: "Cosa applicare",
    hintEmpty: "Scegli un'azione per iniziare.",
  },
  step2: {
    title: "Dove applicare",
    selectedCount: "{selected} di {total} selezionati",
    selectVisible: "Visibili",
    selectAll: "Tutti",
    clear: "Cancella",
    searchPlaceholder: "Cerca alloggio…",
    empty: "Nessun alloggio corrisponde alla tua ricerca.",
  },
  step3: {
    title: "Intervallo e giorni",
    datesInRange: "{count} data nell'intervallo | {count} date nell'intervallo",
    from: "Dal",
    to: "Al",
    presetAll: "Tutti",
    presetWeekdays: "Lun–Ven",
    presetWeekend: "Weekend",
  },
  step4: {
    closeReasonTitle: "Motivo della chiusura",
    availabilityTitle: "Disponibilità",
    closeReasonHint: "Facoltativo — verrà salvato con il blocco.",
    availabilityHint: "Le vendite sono chiuse (stop-sell); la disponibilità viene mantenuta. Modificala solo se lo desideri.",
    closeCommentPlaceholder: "es. manutenzione o uso del proprietario",
    availabilityPlaceholder: "Camere in vendita (vuoto = mantieni)",
    openAvailabilityHint: "Riapre le vendite. Inserisci quante camere offrire (vuoto = mantieni l'attuale).",
    availabilityPlaceholderOpen: "Camere in vendita",
  },
  ratePlan: {
    title: "Tariffa da modificare",
    hint: "Questo tipo ha diverse tariffe. Scegli a quale/i applicare {target}. Le tariffe derivate si adeguano automaticamente.",
    targetPrice: "il prezzo",
    targetMinStay: "il soggiorno minimo",
    default: "standard",
    roomsCount: "{count} camera | {count} camere",
    multiUnitNote: "Verrà applicata a ogni camera che ha la tariffa scelta.",
    fallbackName: "Tariffa",
  },
  price: {
    title: "Nuovo prezzo a notte",
    hint: "Verrà applicato alle date, alle unità e alle tariffe scelte.",
    mixedCurrencyWarning: "Seleziona solo alloggi con la stessa valuta.",
    placeholder: "Valore",
    placeholderCurrency: "Valore in {currency}",
    hintPercent: "Alza o abbassa il prezzo che ogni notte ha già.",
    modeGroupLabel: "Tipo di modifica del prezzo",
    modeFixed: "Prezzo fisso",
    modeFixedHint: "Lo stesso importo in tutte le notti.",
    modePercent: "Percentuale",
    modePercentHint: "Sul prezzo di ogni singola notte.",
    modeAmount: "Importo",
    modeAmountHint: "Aggiungere o togliere su ogni notte.",
    amountPlaceholder: "Es. 10",
    amountHint: "Si somma a quanto costa già ogni notte. Con il segno − scende.",
    percentPlaceholder: "Es. 20",
    percentHint: "Ogni notte viene ricalcolata dal suo prezzo. Il segno − la abbassa (tra {min} % e {max} %).",
    toggleSign: "Passa da aumento a riduzione",
    invalidPercent: "Inserisci una percentuale tra {min} % e {max} %, diversa da 0.",
  },
  minStay: {
    title: "Soggiorno minimo",
    hint: "Numero minimo di notti per data.",
    placeholder: "es. 2",
  },
  summary: {
    empty: "Seleziona unità e intervallo.",
    unitOne: "unità",
    unitMany: "unità",
    dateOne: "data",
    dateMany: "date",
    ready: "{propertyCount} {propertyLabel} · {dateCount} {dateLabel} pronte da applicare.",
    nightOne: "notte",
    nightMany: "notti",
    readyPriceFixed: "{propertyCount} {propertyLabel} · imposterà {price} {currency} su {dateCount} {nightLabel}.",
    readyPricePlus: "{propertyCount} {propertyLabel} · alzerà di {amount} {currency} il prezzo di {dateCount} {nightLabel}.",
    readyPriceMinus: "{propertyCount} {propertyLabel} · abbasserà di {amount} {currency} il prezzo di {dateCount} {nightLabel}.",
    readyPriceUp: "{propertyCount} {propertyLabel} · aumenterà del {percent} % il prezzo di {dateCount} {nightLabel}.",
    readyPriceDown: "{propertyCount} {propertyLabel} · ridurrà del {percent} % il prezzo di {dateCount} {nightLabel}.",
  },
  footer: {
    cancel: "Annulla",
    apply: "Applica modifiche",
    applying: "Applicazione…",
  },
  weekdays: {
    mon: { short: "L", long: "Lunedì" },
    tue: { short: "M", long: "Martedì" },
    wed: { short: "M", long: "Mercoledì" },
    thu: { short: "G", long: "Giovedì" },
    fri: { short: "V", long: "Venerdì" },
    sat: { short: "S", long: "Sabato" },
    sun: { short: "D", long: "Domenica" },
  },
  ownerBlockComment: "Bloccato dal proprietario",
};
